import appConfig from '../../../config/appConfig';
import urlUtils from '../../../utils/urlUtils';
import ApiClient from './apiClient';

export default class ReportsApiClient extends ApiClient {
    getApiUrl(methodName) {
        const apiUrl = appConfig.getReportsApiUrl();

        return urlUtils.join(apiUrl, methodName);
    }
}
